import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=0c58eb5b&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=ts&"
export * from "./NewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=0c58eb5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58eb5b",
  null
  
)

export default component.exports